<script>
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'

export default {
    name : "AddReportingEntityForm",
    components: {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
    },
    props: {
        repGroupData : Object
    },
    data(){
        return {
            newReportingEntities : []
        }
    },
    created(){
        // Initial row
        this.addRow();
    },
    methods : {
        addRow(){
            this.newReportingEntities.push({
                reportingEntity : "",
                isActive : true
            });
        },
        deleteRow(row){
            this.newReportingEntities.splice(row.index,1);
        },
        triggerClose(){
            this.newReportingEntities = [];
            this.$emit('close');
        },
        triggerSubmit(){
            var newEntities = [];
            this.newReportingEntities.forEach(entity=>{
                if (entity.reportingEntity.trim()!="") {
                    newEntities.push({
                        reportingEntity: entity.reportingEntity,
                        isActive: entity.isActive,
                        repGroupId : this.repGroupData.repGroupId
                    });
                }
            })
            this.$emit('save-rep-entity',newEntities);
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="heading">{{repGroupData.reportingGroup}}</span>
                Add Reporting Entities
            </p>
        </header>

        <section class="modal-card-body">
            <b-table
                v-bind:data="newReportingEntities">
                <template
                    slot-scope="props">
                    <b-table-column
                        field=""
                        label="Option">
                        <button class="button is-white"
                            type="button"
                            v-on:click="deleteRow(props)">
                            <span class="icon">
                                <i class="fas fa-trash"></i>
                            </span>
                        </button>
                    </b-table-column>

                    <b-table-column
                        field="reportingEntity"
                        label="Reporting Entity">
                        <b-field>
                            <b-input 
                                v-model="props.row.reportingEntity"
                                type="text"
                                value=""
                                required></b-input>
                        </b-field>
                    </b-table-column>

                    <b-table-column
                        field="isActive"
                        label="Active"
                        width="100">
                        <b-field>
                            <b-switch v-model="props.row.isActive">
                                 {{props.row.isActive==true ? "Yes" : "No" }}
                            </b-switch>
                        </b-field>
                    </b-table-column>
                </template>
            </b-table>
            <!--<br/> -->
            <div class="buttons">&nbsp;&nbsp;
                <a class="button is-text"
                    v-on:click="addRow">
                    <span>+ Add Row</span>
                </a>
            </div>
        </section>
        <footer class="modal-card-foot has-text-left">
            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Cancel</span>
            </a>
            
            <a class="button is-success"
                v-on:click="triggerSubmit">
                <span>Submit</span>
            </a>
        </footer>
    </div>
</template>




// WEBPACK FOOTER //
// src/components/AddReportingEntityForm.vue